import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcFirmware = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12 2a1 1 0 0 0-1 1v2h2V3a1 1 0 0 0-1-1Zm4 0a1 1 0 0 0-1 1v2h2V3a1 1 0 0 0-1-1Zm-3 17v2a1 1 0 1 1-2 0v-2h2Zm-4 0H7v2a1 1 0 1 0 2 0v-2Zm-7-7a1 1 0 0 1 1-1h2v2H3a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h2v-2H3ZM2 8a1 1 0 0 1 1-1h2v2H3a1 1 0 0 1-1-1Zm19 3h-2v2h2a1 1 0 1 0 0-2Zm-2 4h2a1 1 0 1 1 0 2h-2v-2Zm2-8h-2v2h2a1 1 0 1 0 0-2Zm-4 12v2a1 1 0 1 1-2 0v-2h2ZM8 2a1 1 0 0 0-1 1v2h2V3a1 1 0 0 0-1-1Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M17 17V7H7v10h10ZM7 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-icon-accent)",
  height: "6",
  rx: "1",
  width: "6",
  x: "9",
  y: "9"
})), "IcFirmware");

export { IcFirmware };
//# sourceMappingURL=ic-firmware.js.map
